import PersonalDataForm from "./PersonalDataForm"

export default PersonalDataForm
